import { combineReducers } from "redux";
import studentsReducer from "./student";
import applicationListReducer from "./applicationList";
export default combineReducers({
  students: studentsReducer,
  applicationList: applicationListReducer,
});
